import { FilterListSMSIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import { LiveVideoButtonContainer } from '../../VideoTo911/LiveVideoButtonContainer';
import {
  StartChatContainer,
  StartChatButtonNoAccordion,
} from './TF911StartChatAccordion.styles';

interface TF911StartChatNoAccordionInterface {
  handleDefaultStartClick: () => void;
  isCreatingConversation: boolean;
  isForOverview?: boolean;
  isVT911Enabled?: boolean;
  onStartConversation: (message: string) => Promise<{ isSuccess: boolean }>;
}

const TF911StartChatNoAccordion = ({
  handleDefaultStartClick,
  isCreatingConversation,
  isForOverview,
  isVT911Enabled,
  onStartConversation,
}: TF911StartChatNoAccordionInterface) => {
  return (
    <StartChatContainer pb="8px" gridColumnGap="8px">
      {isVT911Enabled && (
        <Box width="50%">
          <LiveVideoButtonContainer
            onStartConversation={onStartConversation}
            isForOverview={isForOverview}
          />
        </Box>
      )}
      <Box
        alignItems="center"
        justifyContent="center"
        horizontal
        width={isVT911Enabled ? '50%' : '100%'}
      >
        <StartChatButtonNoAccordion
          disabled={isCreatingConversation}
          isLoadingProp={isCreatingConversation}
          onClick={handleDefaultStartClick}
        >
          <FilterListSMSIcon width={12} height={12} />
          Start Chat
        </StartChatButtonNoAccordion>
      </Box>
    </StartChatContainer>
  );
};

export default TF911StartChatNoAccordion;
